import { atom } from 'recoil';
import { getMpsStatusSelector } from '../selectors/getMpsStatusSelector';
import type { MpsStatusResponseDTO } from 'gw-edge-client/dist/types/dto/bc/edge/capabilities/billing/dto';

export const mpsStatusAtom = atom<MpsStatusResponseDTO>({
    key: 'mpsStatusAtom',
    default: getMpsStatusSelector
});
